/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// ****************************TRYIT**************************
// Valida el codigo envuado desde el formulario
function submitFormValidate(e) {
    e.preventDefault();
    const code = document.getElementById("validate-code").value;
    activateCartCode(code);
    return false;
  }
  
  function activateCartCode(codeD) {
      const code = "Nala-56758554";
      const urlCode = "https://api.production.tryit.cl/shops/get";
      const urlCart = "https://api.production.tryit.cl/carts/create";
      const shopName = "nala-cl.myshopify.com";
      const cartUrl = window.location.href;
      const shopUrl = window.location.host;
      const urlApp = "https://app.tryit.cl";
    
      sendCodeValidate(code, urlCode).then((resp) => {
      if (resp.ok) {
        localStorage.setItem("codeAuth", code);
        const maxProducts = resp.data.maxProducts;
        const minProducts = resp.data.minProducts;
        getCart(shopName, urlCart, maxProducts, cartUrl, shopUrl, urlApp, minProducts)
            .then((data) => {
                if(typeof data == "number") {
                  const message = "Puedes seleccionar entre "+ minProducts + " y " + maxProducts + " productos para probarlos";
        alertMessage("warning", message);
                  return;
                } else if (typeof data === 'object') {
              const message = "Tienes productos que no se pueden probar: " + data.toString();
              alertMessage("warning", message);
               return;
                } else {
                  window.location.replace(data);
                }
            })
            .catch((error) => console.log("Error:", error));
      } else {
        if(resp.err.name === 'inaciveService') {
          alertMessage("warning", resp.err.message);
        } else {
          window.location.replace("/pages/valida-servicio-de-prueba");
        }
      }
    });
  }
  async function alertMessage(icon, message) {
    await Swal.fire({
      title: "",
      text: message,
      icon,
      allowOutsideClick: false,
      confirmButtonText: "Ok",
    });
  }
  
  // ****************************TRYIT**************************

